import * as api from '@modules/conferencing/api/checkInSearch';
import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  START,
  SUCCESS,
  ERROR,
  createRequestTypes,
} from '@modules/conferencing/actions/global';

const namespace = 'CONFERENCE/CHECKIN_SEARCH';

export const SEARCH = createRequestTypes(`${namespace}/SEARCH`);

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH[START],
  SEARCH[SUCCESS],
  SEARCH[ERROR],
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = (page) => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_SORT_MODEL = `${namespace}/CHANGE_SORT_MODEL`;

export const changeSortModel = (sortModel) => ({
  type: CHANGE_SORT_MODEL,
  payload: sortModel,
});
